// extracted by mini-css-extract-plugin
var _1 = "src-components-ForgotPasswordForm-_TextModalDialog__dialogCloseButton--yhSyZbLsuiZ8LLFPFZwN";
var _2 = "src-components-ForgotPasswordForm-_TextModalDialog__dialogCloseButtonWrapper--Lao_E5PQCaQSSsTtHw0M";
var _3 = "src-components-ForgotPasswordForm-_TextModalDialog__dialogText--kJI73ngo1dxIzVQhjGTL";
var _4 = "src-components-ForgotPasswordForm-_TextModalDialog__textModalDialog--Fo_wFy8DNvEIFNki_Obf";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textModalDialog" }
